import React, { Fragment } from "react";
import { Admin, Capture, Dispatch, ShiftInCharge, VendorAgent } from "../../../../Data/SideMenu/RouteMapping";
import { getUserRole } from "../../../../Services/Shared.service";
import { DropdownItem } from "reactstrap";
import {
  editBookingValidStatus,
  cancelBookingInValidStatus,
} from "../../../../Data/Booking/BookingHistory";

const VendorBookingQuickActions = (props) => {
  const userRole = getUserRole();

  return (
    <Fragment>
      {props.element.isMmt == false && userRole.some((element) => element == VendorAgent) ? null:<DropdownItem
          className="border-0"
          key={"row-edit"}
          disabled={
            editBookingValidStatus.includes(
              props.element.currentBookingStatusType
            )
              ? false
              : true
          }
          onClick={() => {
            props.onClickEditOrRebook(props.element.id, "Edit");
          }}
        >
          <i className="fa fa-pencil"></i> Edit
        </DropdownItem>}
      {userRole.some((element) => element == Admin || element == ShiftInCharge || element == Capture || element == Dispatch || element == VendorAgent) ? <DropdownItem
        className="border-0"
        key={"row-cancel"}
        disabled={
          cancelBookingInValidStatus.includes(
            props.element.currentBookingStatusType
          )
            ? true
            : false
        }
        onClick={() => {
          props.setBookingObj(props.element);
          props.toggleCancelBookingModal();
        }}
      >
        <i className="fa fa-times-circle"></i> Cancel
      </DropdownItem> : ""}
      {userRole.some((element) => element == Capture || element == Admin || element == ShiftInCharge) ? (
        <DropdownItem
          className="border-0"
          key={"row-rebook"}
          onClick={() => {
            props.onClickEditOrRebook(props.element.id, "Rebook");
          }}
        >
          <i className="fa fa-repeat"></i> Rebook
        </DropdownItem>
      ) : (
        ""
      )}
      {userRole.some((element) => element == Dispatch || element == Admin || element == ShiftInCharge || element == VendorAgent) ? (
        <DropdownItem
          className="border-0"
          key={"row-assigndriver"}
          onClick={() => {
            props.setAssignDriverBookingObj(props.element);
            props.toggleAssignDriverModal();
          }}
          disabled={
            props.element.currentBookingStatusType == "Completed" || props.element.currentBookingStatusType == "Cancelled"
              ? true
              : false
          }
        >
          <i className="fa fa-user-plus"></i>{props.element.currentBookingStatusType == "Confirmed" || props.element.currentBookingStatusType == "ReachedPickup" ? "Re-assign Driver" : "Assign Driver"}
        </DropdownItem>
      ) : (
        ""
      )}
      {/* {userRole.some((element) => element == Admin && (props.element.currentBookingStatusType === "New" || props.element.currentBookingStatusType === "VendorAssigned")) ? (
        <DropdownItem
          className="border-0"
          key={"row-assignvendor"}
          onClick={() => {
            props.setVendorBookingObj(props.element);
            props.toggleAssignVendorModal();
          }}
          disabled={
            props.element.currentBookingStatusType == "Completed" || props.element.currentBookingStatusType == "Cancelled"
              ? true
              : false
          }
        >
          <i className="fa fa-user-plus"></i>{props.element.currentBookingStatusType === "VendorAssigned" ? " Re-assign Vendor" : " Assign Vendor"}
        </DropdownItem>
      ) : (
        ""
      )} */}
    </Fragment>
  );
};

export default VendorBookingQuickActions;
